import React from 'react'
import './style.css';

const comingSoon = () => {
  return (
    <div className="coming-soon">
      <h2>
        Coming Soon
      </h2>
    </div>
  )
}

export default comingSoon
